<template>
    <div id="ComponentModalProcessoRegistro">
        <div class="modal fade modern-modal" id="ModalProcessoRegistro" tabindex="-1">
            <div class="modal-dialog modal-dialog-centered modal-modern modal-grande">
                <div class="modal-content modal-modern-content border-0">

                    <!-- botão fechar -->
                    <button type="button"
                            class="btn btn-md btn-icon btn-pill btn-white shadow position-absolute top-0 end-0 mt-n3 me-n3 btn-close-modern"
                            :disabled="loading || saving"
                            data-bs-dismiss="modal">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16">
                            <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z" />
                        </svg>
                    </button>

                    <!-- header -->
                    <div class="modal-modern-header">
                        <div class="header-icon">
                            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none">
                                <path d="M12 4V20M4 12H20" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </div>

                        <div class="header-text">
                            <h2>Itens do processo</h2>
                            <p>
                                Defina a quantidade que <strong>seu setor</strong> quer para cada item deste registro.
                            </p>
                            <div v-if="isLocked" class="alert alert-warning py-2 px-3 mb-0" style="margin-top: 10px;">
                                <b>O Processo já foi iniciado</b>, por isso não é possível alterar os dados deste registro.
                            </div>

                            <div class="text-muted" style="margin-top: 6px;">
                                <div>
                                    <b>Registro:</b> {{ header.nmRegistroNecessidade || ('#' + header.idRegistroNecessidade) }}
                                </div>
                                <div>
                                    <b>Processo:</b> {{ header.dsNomeProcesso || ('#' + header.idProcesso) }}
                                </div>
                                <div>
                                    <b>Proprietário:</b> {{ header.proprietario?.nmUsuario +' - '+ header.proprietario?.dsEmail  || ('#' + header.idProcesso) }}
                                </div>
                                <div>
                                    <b>Setor:</b> {{ header.setor?.nmSetor || ('#' + header.idSetor) }}
                                </div>
                                <div v-if="header.dtLimite">
                                    <b>Prazo:</b> {{ formatarData(header.dtLimite) }}
                                </div>
                            </div>
                        </div>

                        <div class="header-status">
                            <span v-if="loading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                            <span class="total-chip">Itens: <b>{{ itensFiltrados.length }}</b></span>
                        </div>
                    </div>

                    <div class="modal-modern-body">
                        <div class="section-stack">
                            <div class="section-card">
                                <div class="dependency-toolbar">
                                    <div class="toolbar-text">
                                        Busque por <strong>nome</strong> / <strong>referência</strong>.
                                    </div>
                                    <div class="toolbar-actions">
                                        <div class="input-group modern-input" style="max-width: 360px;">
                                            <span class="input-group-text">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none">
                                                    <path d="M21 21L16.65 16.65M18 10.5C18 14.6421 14.6421 18 10.5 18C6.35786 18 3 14.6421 3 10.5C3 6.35786 6.35786 3 10.5 3C14.6421 3 18 6.35786 18 10.5Z" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
                                                </svg>
                                            </span>
                                            <input type="text"
                                                   class="form-control"
                                                   v-model="filter"
                                                   :disabled="loading"
                                                   placeholder="Buscar..." />
                                        </div>
                                    </div>
                                </div>

                                <div class="table-wrapper modern-table">
                                    <table class="custom-table">
                                        <thead>
                                            <tr>
                                                <th style="white-space: nowrap;">Item</th>
                                                <th class="text-center" style="white-space: nowrap; width: 12%;">Unidade de Medida</th>
                                                <th class="text-center" style="white-space: nowrap; width: 16%;">Quantidade</th>
                                            </tr>
                                        </thead>

                                        <tbody>
                                            <tr v-for="(it, i) in itensFiltrados" :key="it.idRegistroNecessidadeItem || (it.idItem + '-' + i)">
                                                <td data-label="Item">
                                                    <div class="item-name">{{ it.nmItem || ('Item ' + it.idItem) }}</div>
                                                    <div class="item-details">
                                                        {{ it.cdReferencia || it.cdItem || '-' }}
                                                        <span v-if="it.tpItem"> • {{ it.tpItem }}</span>
                                                    </div>
                                                </td>

                                                <td data-label="Unid." class="text-center">
                                                    <span class="id-badge">{{ it.nmUnidadeMedida || it.idUnidadeMedida || '-' }}</span>
                                                </td>

                                                <td data-label="Quantidade" class="text-center">
                                                    <input type="number"
                                                           class="form-control form-control-sm text-center"
                                                           v-model.number="it.qtd"
                                                           :disabled="loading || saving"
                                                           min="0"
                                                           step="0.01"
                                                           placeholder="0" />
                                                    <small v-if="it._invalid" class="text-danger">
                                                        Informe uma quantidade válida.
                                                    </small>
                                                </td>
                                            </tr>

                                            <tr v-if="!loading && itensFiltrados.length === 0">
                                                <td colspan="4" class="empty-state">
                                                    <div class="empty-content">
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" fill="currentColor" viewBox="0 0 16 16" class="empty-icon">
                                                            <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                                                            <path d="M8.93 6.588l-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533z" />
                                                            <circle cx="8" cy="4.5" r="1" />
                                                        </svg>
                                                        <h3 class="empty-title">Nada encontrado</h3>
                                                        <p class="empty-description">Tente ajustar o filtro.</p>
                                                    </div>
                                                </td>
                                            </tr>

                                            <tr v-if="loading">
                                                <td colspan="4" class="empty-state">
                                                    <div class="empty-content">
                                                        <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                                        <h3 class="empty-title">Carregando...</h3>
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- footer ações -->
                    <div class="modal-modern-footer mt-auto">
                        <div class="footer-actions">
                            <button type="button"
                                    class="modern-btn modern-btn-secondary"
                                    :disabled="saving"
                                    data-bs-dismiss="modal">
                                Fechar
                            </button>

                            <button type="button"
                                    class="modern-btn modern-btn-success"
                                    :disabled="loading || saving || !podeSalvar"
                                    @click="salvar">
                                <span v-if="saving" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                <span v-if="!saving">Salvar quantidades</span>
                                <span v-else>Salvando...</span>
                            </button>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { urlApi, avisoErro, avisoToast } from '@/config/global'
    import axios from 'axios'

    export default {
        name: 'ModalProcessoRegistro',

        props: {
            saveUrl: { type: String, default: null },
        },

        data() {
            return {
                bsModal: null,
                loading: false,
                saving: false,

                header: {
                    idRegistroNecessidade: null,
                    nmRegistroNecessidade: null,
                    idProcesso: null,
                    dsNomeProcesso: null,
                    idSetor: null,
                    dtLimite: null,
                    flProcessoIniciado: false,
                },

                itens: [], // itens carregados do registro
                filter: '',
            }
        },

        computed: {
            isLocked() {
                return this.header?.flProcessoIniciado === true
            },

            itensFiltrados() {
                const termo = (this.filter || '').trim().toLowerCase()
                if (!termo) return this.itens

                return this.itens.filter(it => {
                    const a = String(it.nmItem ?? '').toLowerCase()
                    const b = String(it.cdReferencia ?? '').toLowerCase()
                    const c = String(it.cdItem ?? '').toLowerCase()
                    return a.includes(termo) || b.includes(termo) || c.includes(termo)
                })
            },

            podeSalvar() {
                if (this.isLocked) return false
                if (!this.itens.length) return false
                return this.itens.some(x => Number(x.qtd || 0) > 0)
            },
        },

        mounted() {
            const el = document.getElementById('ModalProcessoRegistro')
            const bs = window.bootstrap || window.Bootstrap
            if (el && bs?.Modal) {
                this.bsModal = new bs.Modal(el)
            }
            if (el) {
                el.addEventListener('hidden.bs.modal', this.onModalHidden)
            }
        },

        beforeUnmount() {
            const el = document.getElementById('ModalProcessoRegistro')
            if (el) el.removeEventListener('hidden.bs.modal', this.onModalHidden)
        },

        methods: {
            onModalHidden() {
                this.reset()
                this.$emit('close')
            },

            reset() {
                this.loading = false
                this.saving = false
                this.filter = ''
                this.header = {
                    idRegistroNecessidade: null,
                    nmRegistroNecessidade: null,
                    idProcesso: null,
                    dsNomeProcesso: null,
                    idSetor: null,
                    dtLimite: null,
                    flProcessoIniciado: false,
                }
                this.itens = []
            },

            async abrir(row) {
                const idReg = Number(row?.registroNecessidade.idRegistroNecessidade || 0)
                if (!idReg) {
                    avisoToast('Registro inválido para abrir itens do processo.', 'warning')
                    return
                }

                this.header = {
                    idRegistroNecessidade: idReg,
                    nmRegistroNecessidade: row?.registroNecessidade.nmRegistroNecessidade ?? null,
                    idProcesso: row?.registroNecessidade.idProcesso ?? null,
                    dsNomeProcesso: row?.registroNecessidade.dsNomeProcesso ?? null,
                    idSetor: row?.registroNecessidade.idSetor ?? null,
                    dtLimite: row?.registroNecessidade.dtLimite ?? null,
                    flProcessoIniciado: !!row?.registroNecessidade.flProcessoIniciado,
                    proprietario: row?.proprietario,
                    setor: row?.setor
                }

                this.resetItensSomente()
                this.bsModal?.show?.()

                await this.getItensDoRegistro()
            },

            resetItensSomente() {
                this.loading = false
                this.saving = false
                this.filter = ''
                this.itens = []
            },

            async getItensDoRegistro() {
                this.loading = true
                try {
                    const res = await axios.get(`${urlApi}/RegistroNecessidade/GetRegistroNecessidadeItemDetalhado`, {
                        params: { idRegistroNecessidade: this.header.idRegistroNecessidade }
                    })

                    if (!res.data?.success) {
                        avisoToast(res.data?.msg || 'Erro ao carregar itens do registro!', 'warning')
                        return
                    }

                    const grid = res.data.data
                    const rows = grid?.rows || grid || []
                    const arr = Array.isArray(rows) ? rows : []

                    const norm = arr.map(x => x.registroNecessidadeItem || x)

                    this.itens = norm.map(it => ({
                        idRegistroNecessidadeItem: it.idRegistroNecessidadeItem ?? 0,
                        idItem: it.idItem ?? null,
                        nmItem: it.nmItem ?? null,
                        cdReferencia: it.cdReferencia ?? null,
                        cdItem: it.cdItem ?? null,
                        tpItem: it.tpItem ?? null,
                        idUnidadeMedida: it.idUnidadeMedida ?? null,
                        nmUnidadeMedida: it.nmUnidadeMedida ?? null,
                        qtd: Number(it.qtdSetor ?? it.qtdItem ?? it.qtdRequisitada ?? 0),

                        _invalid: false,
                    }))
                } catch (err) {
                    console.error(err)
                    avisoErro(err.response?.data || err.message || 'Erro ao carregar itens do registro!')
                } finally {
                    this.loading = false
                }
            },

            validar() {
                let ok = true
                this.itens.forEach(it => {
                    const v = Number(it.qtd)
                    const valid = !(isNaN(v) || v < 0)
                    it._invalid = !valid
                    if (!valid) ok = false
                })
                return ok
            },

            async salvar() {
                if (!this.validar()) {
                    avisoErro('Verifique as quantidades informadas.')
                    return
                }
                if (this.isLocked) {
                    avisoToast('O Processo já foi iniciado, por isso não é possível alterar este registro.', 'warning')
                    return
                }
                const payload = {
                    idRegistroNecessidade: this.header.idRegistroNecessidade,
                    idProcesso: this.header.idProcesso,
                    idSetor: this.header.idSetor,
                    itens: this.itens
                        .map(it => ({
                            idRegistroNecessidadeItem: it.idRegistroNecessidadeItem,
                            idItem: it.idItem,
                            idUnidadeMedida: it.idUnidadeMedida,
                            qtd: Number(it.qtd || 0),
                        }))
                        .filter(x => x.qtd > 0),
                }

                if (!payload.itens.length) {
                    avisoErro('Informe ao menos uma quantidade maior que 0.')
                    return
                }
                this.saving = true
                try {
                    const res = await axios.post(`${urlApi}/RegistroNecessidade/PostRegistroNecessidadeItemQtd`, payload)

                    if (!res.data?.success) {
                        avisoErro(res.data?.msg || 'Erro ao salvar quantidades.')
                        return
                    }

                    avisoToast('Quantidades salvas com sucesso!', 'success')
                    this.bsModal?.hide?.()
                    this.$emit('saved', payload)
                } catch (err) {
                    console.error(err)
                    avisoErro(err.response?.data || err.message || 'Erro ao salvar quantidades.')
                } finally {
                    this.saving = false
                }
            },

            formatarData(dataISO) {
                if (!dataISO) return ''
                const d = new Date(dataISO)
                return d.toLocaleDateString('pt-BR')
            },

            formatarQtd(v) {
                if (v === null || v === undefined) return '0'
                try {
                    return Number(v).toLocaleString('pt-BR')
                } catch {
                    return String(v)
                }
            },
        },
    }
</script>

<style scoped>
    .modal-grande {
        width: 100% !important;
        max-width: calc(100vw - 40px) !important;
        margin: auto;
        margin-top: 20px;
        padding: 0 12px;
    }

        .modal-grande .modal-content {
            min-height: 95vh;
        }

    .modern-modal .modal-modern-content {
        border-radius: 20px;
        background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
        box-shadow: 0 20px 60px rgba(15, 23, 42, 0.18);
        position: relative;
    }

    .btn-close-modern {
        border-radius: 50% !important;
        border: 2px solid rgba(148, 163, 184, 0.25) !important;
        background: #ffffff !important;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 44px;
        height: 44px;
        box-shadow: 0 12px 30px rgba(15, 23, 42, 0.12);
        transition: transform 0.2s ease, box-shadow 0.2s ease;
    }

    .btn-close-modern:hover {
        transform: scale(1.07);
        box-shadow: 0 14px 34px rgba(37, 99, 235, 0.2);
        background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%) !important;
        border-color: transparent !important;
    }

    .btn-close-modern:hover svg {
        color: #ffffff;
    }

    .btn-close-modern:disabled {
        opacity: 0.7;
        cursor: not-allowed;
    }

    .btn-md {
        z-index: 1001;
    }

    .modal-modern-header {
        display: flex;
        align-items: flex-start;
        gap: 18px;
        padding: 32px 32px 24px;
        position: relative;
    }

    .modal-modern-header::after {
        content: '';
        position: absolute;
        bottom: 0;
        left: 32px;
        right: 32px;
        height: 1px;
        background: linear-gradient(90deg, transparent, rgba(148, 163, 184, 0.35), transparent);
    }

    .header-icon {
        width: 64px;
        height: 64px;
        border-radius: 18px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: linear-gradient(135deg, rgba(16, 185, 129, 0.16) 0%, rgba(59, 130, 246, 0.16) 100%);
        color: #0f766e;
        flex-shrink: 0;
    }

    .header-text {
        flex: 1;
        display: flex;
        flex-direction: column;
        gap: 6px;
    }

    .header-text h2 {
        margin: 0;
        font-size: 24px;
        font-weight: 700;
        color: #0f172a;
    }

    .header-text p {
        margin: 0;
        color: #475569;
        font-size: 14px;
        max-width: 520px;
        line-height: 1.4;
    }

    .header-status {
        display: flex;
        align-items: center;
        gap: 12px;
        flex-wrap: wrap;
    }

    .modal-modern-body {
        padding: 28px 32px 24px;
        display: flex;
        flex-direction: column;
        gap: 24px;
    }

    .section-stack {
        display: flex;
        flex-direction: column;
        gap: 22px;
    }

    .section-card {
        background: linear-gradient(135deg, rgba(255, 255, 255, 0.9) 0%, rgba(248, 250, 252, 0.95) 100%);
        border: 1px solid rgba(226, 232, 240, 0.8);
        border-radius: 18px;
        padding: 20px 22px;
        box-shadow: 0 12px 28px rgba(148, 163, 184, 0.15);
        display: flex;
        flex-direction: column;
        gap: 18px;
    }

    .dependency-toolbar {
        background: rgba(248, 250, 252, 0.9);
        border: 1px solid rgba(226, 232, 240, 0.8);
        border-radius: 16px;
        padding: 16px 18px;
        display: flex;
        flex-wrap: wrap;
        gap: 16px;
        align-items: center;
        justify-content: space-between;
    }

    .toolbar-text {
        color: #475569;
        font-size: 13px;
        max-width: 460px;
        line-height: 1.5;
    }

    .toolbar-actions {
        display: flex;
        align-items: center;
        gap: 14px;
        flex-wrap: wrap;
    }

    .modern-input .input-group-text {
        background: rgba(248, 250, 252, 0.9);
        border: 1px solid rgba(203, 213, 225, 0.7);
        border-right: none;
        border-radius: 12px 0 0 12px;
        color: #64748b;
    }

    .modern-input .form-control {
        border-radius: 0 12px 12px 0;
        border: 1px solid rgba(203, 213, 225, 0.7);
        padding: 10px 14px;
        font-size: 14px;
    }

    .total-chip {
        padding: 8px 14px;
        background: linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%);
        border: 2px solid #bfdbfe;
        border-radius: 8px;
        font-size: 13px;
        font-weight: 600;
        color: #1e40af;
    }

    .table-wrapper {
        margin-top: 4px;
    }

    .modern-table .custom-table {
        width: 100%;
        border-collapse: collapse;
        border-radius: 16px;
        overflow: hidden;
        border: 1px solid rgba(148, 163, 184, 0.2);
    }

    .modern-table .custom-table thead {
        background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
    }

    .modern-table .custom-table th,
    .modern-table .custom-table td {
        padding: 14px 18px;
        border-bottom: 1px solid rgba(148, 163, 184, 0.16);
        font-size: 14px;
        color: #1e293b;
    }

    .modern-table .custom-table th {
        font-weight: 700;
        text-transform: uppercase;
        font-size: 12px;
        letter-spacing: 0.45px;
    }

    .modern-table .custom-table tbody tr:hover {
        background: rgba(59, 130, 246, 0.08);
    }

    .item-name {
        font-weight: 600;
        color: #0f172a;
        font-size: 14px;
        margin-bottom: 4px;
    }

    .item-details {
        font-size: 13px;
        color: #64748b;
    }

    .number-badge {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        padding: 6px 12px;
        border-radius: 10px;
        font-weight: 700;
        font-size: 13px;
        background: linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%);
        border: 1px solid rgba(59, 130, 246, 0.3);
        color: #1d4ed8;
    }

    .id-badge {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        padding: 6px 12px;
        border-radius: 10px;
        font-weight: 600;
        font-size: 13px;
        background: linear-gradient(135deg, #f1f5f9 0%, #e2e8f0 100%);
        border: 1px solid rgba(148, 163, 184, 0.3);
        color: #475569;
    }

    .form-control {
        border-radius: 12px;
        border: 2px solid rgba(148, 163, 184, 0.25);
        padding: 8px 12px;
        font-size: 14px;
        transition: border-color 0.2s ease, box-shadow 0.2s ease;
        background: #ffffff;
        color: #1f2937;
    }

    .form-control:focus {
        border-color: rgba(37, 99, 235, 0.6);
        box-shadow: 0 0 0 4px rgba(37, 99, 235, 0.12);
        outline: none;
    }

    .empty-state {
        padding: 32px 24px;
        text-align: center;
    }

    .empty-content {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 12px;
    }

    .empty-icon {
        color: #94a3b8;
    }

    .empty-title {
        margin: 0;
        font-size: 18px;
        font-weight: 700;
        color: #0f172a;
    }

    .empty-description {
        margin: 0;
        font-size: 14px;
        color: #64748b;
    }

    .modal-modern-footer {
        padding: 0 32px 32px;
    }

    .footer-actions {
        display: flex;
        justify-content: flex-end;
        gap: 12px;
        flex-wrap: wrap;
    }

    .modern-btn {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        gap: 8px;
        padding: 12px 22px;
        border-radius: 14px;
        font-weight: 600;
        font-size: 14px;
        letter-spacing: 0.3px;
        text-transform: uppercase;
        border: none;
        cursor: pointer;
        transition: transform 0.2s ease, box-shadow 0.2s ease;
        box-shadow: 0 8px 22px rgba(15, 23, 42, 0.12);
        color: #ffffff;
    }

    .modern-btn:hover {
        transform: translateY(-2px);
    }

    .modern-btn:disabled {
        opacity: 0.6;
        cursor: not-allowed;
        transform: none;
    }

    .modern-btn-secondary {
        background: linear-gradient(135deg, #94a3b8 0%, #64748b 100%);
    }

    .modern-btn-success {
        background: linear-gradient(135deg, #10b981 0%, #059669 100%);
    }

    .spinner-border-sm {
        width: 1rem;
        height: 1rem;
        border-width: 0.15em;
    }

    @media (max-width: 768px) {
        .modal-modern-header,
        .modal-modern-body,
        .modal-modern-footer {
            padding: 24px 20px;
        }

        .modal-modern-header::after {
            left: 20px;
            right: 20px;
        }

        .modal-modern-header {
            flex-wrap: wrap;
        }

        .header-status {
            width: 100%;
        }

        .dependency-toolbar {
            flex-direction: column;
            align-items: stretch;
        }

        .toolbar-actions {
            justify-content: stretch;
        }
    }

    /* Dark mode */
    [data-bs-theme="dark"] .modern-modal .modal-modern-content {
        background: linear-gradient(135deg, #0f172a 0%, #111826 100%) !important;
        box-shadow: 0 20px 60px rgba(0, 0, 0, 0.55);
    }

    [data-bs-theme="dark"] .modal-modern-header::after {
        background: linear-gradient(90deg, transparent, rgba(148, 163, 184, 0.2), transparent);
    }

    [data-bs-theme="dark"] .header-icon {
        background: linear-gradient(135deg, rgba(16, 185, 129, 0.26) 0%, rgba(59, 130, 246, 0.26) 100%);
        color: #34d399;
    }

    [data-bs-theme="dark"] .header-text h2 {
        color: #f8fafc;
    }

    [data-bs-theme="dark"] .header-text p {
        color: #94a3b8;
    }

    [data-bs-theme="dark"] .section-card {
        background: linear-gradient(135deg, rgba(15, 23, 42, 0.9) 0%, rgba(30, 41, 59, 0.94) 100%);
        border-color: rgba(71, 85, 105, 0.55);
    }

    [data-bs-theme="dark"] .dependency-toolbar {
        background: rgba(15, 23, 42, 0.86);
        border-color: rgba(71, 85, 105, 0.6);
    }

    [data-bs-theme="dark"] .toolbar-text {
        color: #cbd5f5;
    }

    [data-bs-theme="dark"] .modern-input .input-group-text {
        background: rgba(15, 23, 42, 0.82);
        border-color: rgba(71, 85, 105, 0.6);
        color: #94a3b8;
    }

    [data-bs-theme="dark"] .modern-input .form-control {
        background: rgba(15, 23, 42, 0.82);
        border-color: rgba(71, 85, 105, 0.6);
        color: #e2e8f0;
    }

    [data-bs-theme="dark"] .total-chip {
        background: linear-gradient(135deg, #1e3a5f 0%, #1e40af 100%);
        border-color: #3b82f6;
        color: #93c5fd;
    }

    [data-bs-theme="dark"] .modern-table .custom-table {
        border-color: rgba(71, 85, 105, 0.6);
    }

    [data-bs-theme="dark"] .modern-table .custom-table thead {
        background: linear-gradient(135deg, #1f2937 0%, #111827 100%);
    }

    [data-bs-theme="dark"] .modern-table .custom-table th,
    [data-bs-theme="dark"] .modern-table .custom-table td {
        color: #e2e8f0;
        border-color: rgba(71, 85, 105, 0.5);
    }

    [data-bs-theme="dark"] .modern-table .custom-table tbody tr:hover {
        background: rgba(59, 130, 246, 0.18);
    }

    [data-bs-theme="dark"] .item-name {
        color: #e2e8f0;
    }

    [data-bs-theme="dark"] .item-details {
        color: #94a3b8;
    }

    [data-bs-theme="dark"] .number-badge {
        background: linear-gradient(135deg, #374151 0%, #4b5563 100%);
        border-color: rgba(71, 85, 105, 0.6);
        color: #e5e7eb;
    }

    [data-bs-theme="dark"] .id-badge {
        background: linear-gradient(135deg, #374151 0%, #4b5563 100%);
        border-color: rgba(71, 85, 105, 0.6);
        color: #e5e7eb;
    }

    [data-bs-theme="dark"] .form-control {
        background: rgba(15, 23, 42, 0.8);
        border-color: rgba(148, 163, 184, 0.2);
        color: #e2e8f0;
    }

    [data-bs-theme="dark"] .form-control:focus {
        border-color: rgba(59, 130, 246, 0.6);
        box-shadow: 0 0 0 4px rgba(59, 130, 246, 0.15);
    }

    [data-bs-theme="dark"] .empty-title {
        color: #f9fafb;
    }

    [data-bs-theme="dark"] .empty-description {
        color: #9ca3af;
    }

    [data-bs-theme="dark"] .btn-close-modern {
        background: rgba(15, 23, 42, 0.9) !important;
        border-color: rgba(148, 163, 184, 0.25) !important;
    }

    [data-bs-theme="dark"] .btn-close-modern svg {
        color: #e2e8f0;
    }

    [data-bs-theme="dark"] .btn-close-modern:hover {
        background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%) !important;
    }
</style>
